import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Upload = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4352 2.18009L16.9375 6.68234H16.9175C17.1576 6.92246 17.1576 7.32266 16.9175 7.56278C16.7974 7.68284 16.6373 7.74287 16.4772 7.74287C16.3172 7.74287 16.1571 7.68284 16.037 7.56278L12.6053 4.13107V15.8269C12.6053 16.1671 12.3252 16.4472 11.985 16.4472C11.6448 16.4472 11.3647 16.1671 11.3647 15.8269V4.13107L7.93296 7.56278C7.69284 7.8029 7.29264 7.8029 7.05252 7.56278C6.8124 7.32266 6.8124 6.92246 7.05252 6.68234L11.5548 2.18009C11.7949 1.93997 12.1951 1.93997 12.4352 2.18009ZM20.7594 19.0685C20.7594 18.7284 21.0395 18.4482 21.3797 18.4482C21.7199 18.4482 22 18.7284 22 19.0685V21.3797C22 21.7199 21.7199 22 21.3797 22H2.62031C2.28014 22 2 21.7199 2 21.3797V19.0685C2 18.7284 2.28014 18.4482 2.62031 18.4482C2.96048 18.4482 3.24062 18.7284 3.24062 19.0685V20.7494H20.7594V19.0685Z"
    />
  </svg>
)

export default withDefaultStyles(Upload)
